import { GzPolicyUiSettingsGridDataProvider } from '../../../../../../common/policyPanel/uiSettings/gridTemplate/gridComponents/gridView/dataProvider/GzPolicyUiSettingsGridDataProvider';
import { DeviceControlExclusionRuleItem } from '@nirvana/shared/dtos/types/policies/common';
import { Column, ColumnKeys } from './grid-config';
import { SetFiltersRequest } from '../../../../../../../grid/types/common';
import { convertRegexFilterToStartsWithFilter } from '../../../../../../common/policyPanel/uiSettings/gridTemplate/utils/filters-converters';
import { sortByColumn } from './utils/sorters';

export class GzDeviceControlExclusionsGridDataProvider extends GzPolicyUiSettingsGridDataProvider<
  Column,
  ColumnKeys,
  DeviceControlExclusionRuleItem
> {
  sortByColumnMethod(
    a: DeviceControlExclusionRuleItem,
    b: DeviceControlExclusionRuleItem,
    sortColumnName: string,
    sortDirection: string
  ): number {
    return sortByColumn(a, b, sortColumnName, sortDirection);
  }

  async setFilters(request: SetFiltersRequest<ColumnKeys>): Promise<{} | undefined> {
    // convert regex to startsWith
    convertRegexFilterToStartsWithFilter(request, ColumnKeys.EXCEPTION);
    convertRegexFilterToStartsWithFilter(request, ColumnKeys.DESCRIPTION);
    return;
  }
}
